import { Stack, Text, Title } from '@mantine/core';
import { Workflow } from '@/app/workflows/actions/interfaces';
import { useFormContext } from '../../contexts/formContext';
import { useSingleWorkflow } from '@/app/workflows/components/table/query/useWorkflowsQuery';
import { useWorkflow } from '../../../../../../../contexts/getWorkflow';

const getFilename = (filename: Workflow['meta']['filename'], workflow: Workflow) => {
  let basename = 'asset-name';

  if (filename?.useId) {
    basename += `_${workflow.id}`;
  }
  if (filename?.usePresetName) {
    basename += `_${workflow.name}`;
  }

  if (filename?.useSuffix) {
    basename += `_${workflow.meta?.filename?.useSuffix}`;
  }

  return basename;
};

export const ExportName = (props: Workflow['meta']['filename']) => {
  const form = useFormContext();
  const id = form.getValues().id;
  const initialWorkflow = useSingleWorkflow(id);
  const { getWorkflow } = useWorkflow();

  const workflow = getWorkflow() ?? initialWorkflow;

  if (!workflow) {
    return null;
  }

  const name = getFilename(props, workflow);
  return (
    <Stack>
      <Title order={5}>Filename preview</Title>
      <Text>{name}</Text>
    </Stack>
  );
};
